// extracted by css-extract-rspack-plugin
export default {"projectInfo":"uqixe0jq0ggicEl0","projectInfoRow":"rSErRPci6C41K2T4","projectInfoLabel":"Xqjigx8nKioVACZu"};